<template>
  <div>
    <v-row class="mt-2" no-gutters>
      <v-col cols="12" lg="3" md="4">
        <v-text-field v-model="campName" class="rounded-lg" clear-icon="mdi-close-circle-outline" clearable dense
                      label="نام کمپین" outlined/>
      </v-col>
    </v-row>
    <campaign-list-item v-for="(item, i) in mlModel" :key="i + 'msg'" :index="i" :item.sync="item"
                        :loading="i === 0 && loading" :show-delete="mlModel.length > 1"
                        title="پیام" @deleteRow="deleteRow(i)"/>

    <v-card-actions class="px-0">
      <v-btn :disabled="!canMore" block class="rounded-lg btn-send-sms ma-0"
             depressed width="100%" @click="addRow">
        <v-icon left>mdi-plus</v-icon>
        افزودن پیام جدید
      </v-btn>
    </v-card-actions>

    <v-card-actions class="justify-end px-0">
      <v-btn :disabled="!(mlModel && mlModel.length && !!campName && canMore)" class="rounded-lg btn-send-sms ma-0"
             depressed @click="submit">
        <v-icon left>mdi-content-save-plus-outline</v-icon>
        ثبت کمپین
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import CampaignListItem from "@/view/content/pickers/campaign/campaignListItem.vue";

export default {
  name: "createCampaign",

  components: {CampaignListItem},

  data: () => ({
    campName: '',
    loading: false,
    mlModel: [{
      gap: 0,
      type: 'day',
      title: 'متن1',
      text: '\nلغو11',
      lang: '',
      msgCount: 0
    }]
  }),

  computed: {
    canMore() {
      return this.mlModel?.filter(item =>
          (!!item.date || (item.gap != null && item.gap >= 0))
          && !!item.title
          && !!item.text.trim()
          // && !!item.Operator
          && item.text.includes('لغو11')
        // && (Object.hasOwn(item, 'link')
        //   ? !!item.link && this.isDomain(item.link)
        //   : true)
      )?.length === this.mlModel?.length
      // && (!!this.campName && this.campName.length >= 3)
    }
  },

  methods: {
    submit(e) {
      this.loading = true

      const numList = ['989998884521', '989998884522', '989998884523']

      let obj = {
        name: '',
        title: [],
        text: [],
        gap: [],
        type: [],
        Operator: [],
        count: 0
      };
      this.mlModel.forEach(({title, text, gap, msgCount, type}, index) => {
        obj.name = this.campName
        obj.title.push(title)
        obj.text.push(text)
        obj.gap.push(gap)
        obj.type.push(type)
        obj.Operator.push(numList[Math.floor(index % numList.length)])
        obj.count += msgCount
      })

      this.requestApiPostPayamak('campaign/store', {
        campaign: obj
      })
        .then(({data}) => {
          this.$emit('fetch', data.data)
        })
        .catch(({response}) => console.log('response: ', response))
        .finally(() => this.loading = false)
    },
    addRow() {
      if (!this.mlModel) return

      let obj = {
        title: `پیام ${this.mlModel?.length + 1 || 2}`,
        gap: null,
        text: '\nلغو11',
        type: 'day'
      }
      // if (this.sendPagesTab === 1) {
      //   obj.link = ''
      // }

      if (this.mlModel?.length >= 10) return this.$toast.error('حداکثر 10 مورد میتوان اضافه نمود.')
      this.mlModel.push(obj);
    },
    deleteRow(index) {
      this.mlModel.splice(index, 1)
      if (index === 0)
        this.mlModel[0].gap = 0
    },
  }
}
</script>

<style scoped>

</style>